/**
 * CustomProductCard Web Component
 * Standardized across Homepage, Collection, Search, and Related Products
 */
if (!customElements.get('custom-product-card')) {
  class CustomProductCard extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      const swatch = event.target.closest('.swatch-btn');
      if (swatch) {
        this.handleSwatchClick(swatch);
        return;
      }

      const submitBtn = event.target.closest('.product-card__submit-btn');
      if (submitBtn) {
        event.preventDefault();
        event.stopPropagation();
        this.handleAddToCart(submitBtn);
      }
    }

    handleSwatchClick(swatch) {
      if (swatch.classList.contains('active')) return;

      // 1. Toggle swatch states
      this.querySelectorAll('.swatch-btn').forEach(btn => {
        btn.classList.remove('active');
        btn.setAttribute('aria-pressed', 'false');
      });
      swatch.classList.add('active');
      swatch.setAttribute('aria-pressed', 'true');

      // 2. Update variant inputs and links
      const variantId = swatch.getAttribute('data-variant-id');
      const idInput = this.querySelector('.product-variant-id-input');
      if (idInput) idInput.value = variantId;

      const imageLink = this.querySelector('.product-card__image-link');
      const titleLink = this.querySelector('.product-card__title');
      if (variantId) {
        if (imageLink) {
          try {
            const u = new URL(imageLink.href, window.location.origin);
            u.searchParams.set('variant', variantId);
            imageLink.href = u.toString();
          } catch(e) {}
        }
        if (titleLink) {
          try {
            const u = new URL(titleLink.href, window.location.origin);
            u.searchParams.set('variant', variantId);
            titleLink.href = u.toString();
          } catch(e) {}
        }
      }

      // 3. Update Image to matching backend variant image
      const newImageUrl = swatch.getAttribute('data-variant-image');
      const image = this.querySelector('.product-card__image');
      if (newImageUrl && image) {
        image.src = newImageUrl;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
      }

      // 4. Update Price & Compare Price
      const newPrice = swatch.getAttribute('data-variant-price');
      const newComparePrice = swatch.getAttribute('data-variant-compare-price');
      const priceEl = this.querySelector('.product-card__price-value');
      const compareEl = this.querySelector('.product-card__price-compare');
      
      if (newPrice && priceEl) priceEl.textContent = newPrice;
      
      if (compareEl) {
        if (newComparePrice) {
          compareEl.textContent = newComparePrice;
          compareEl.style.display = '';
        } else {
          compareEl.textContent = '';
          compareEl.style.display = 'none';
        }
      }

      // 5. Update Sale (Discount) Badge
      const newPercent = swatch.getAttribute('data-variant-percent');
      const saleBadgeEl = this.querySelector('.product-card__badge.badge--sale');
      if (saleBadgeEl) {
        if (newPercent) {
          saleBadgeEl.textContent = newPercent;
          saleBadgeEl.style.display = '';
          const parentContainer = saleBadgeEl.closest('.product-card__discount-badge');
          if (parentContainer) parentContainer.style.display = '';
        } else {
          saleBadgeEl.textContent = '';
          saleBadgeEl.style.display = 'none';
          const parentContainer = saleBadgeEl.closest('.product-card__discount-badge');
          if (parentContainer) parentContainer.style.display = 'none';
        }
      } else if (newPercent) {
        let discountContainer = this.querySelector('.product-card__discount-badge');
        if (!discountContainer) {
          discountContainer = document.createElement('div');
          discountContainer.className = 'product-card__discount-badge';
          const wrapper = this.querySelector('.product-card__image-wrapper');
          if (wrapper) wrapper.appendChild(discountContainer);
        }
        if (discountContainer) {
          const newBadge = document.createElement('span');
          newBadge.className = 'product-card__badge badge--sale';
          newBadge.textContent = newPercent;
          discountContainer.appendChild(newBadge);
          discountContainer.style.display = '';
        }
      }

      // 6. Update Availability / Button State
      const available = swatch.getAttribute('data-variant-available') === 'true';
      const submitBtn = this.querySelector('.product-card__submit-btn');
      if (submitBtn) {
        if (available) {
          submitBtn.disabled = false;
          submitBtn.querySelector('.btn-text').textContent = 'Add to Cart';
        } else {
          submitBtn.disabled = true;
          submitBtn.querySelector('.btn-text').textContent = 'Sold Out';
        }
      }
    }

    handleAddToCart(submitBtn) {
      if (submitBtn.classList.contains('loading')) return;

      submitBtn.classList.add('loading');
      submitBtn.disabled = true;

      const idInput = this.querySelector('.product-variant-id-input');
      if (!idInput) {
        submitBtn.classList.remove('loading');
        submitBtn.disabled = false;
        return;
      }

      const variantId = idInput.value;
      const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      const url = root + 'cart/add';

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      formData.append('sections', 'ajax-cart,ajax-cart-icon');
      formData.append('sections_url', window.location.pathname);

      fetch(url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
      .then(response => {
        return response.json().then(json => {
          if (!response.ok) {
            throw new Error(json.description || json.message || 'AJAX cart add failed');
          }
          return json;
        });
      })
      .then(data => {
        const ajaxCartElement = document.querySelector('ajax-cart');
        const cartProElement = document.querySelector('cart-pro');
        
        if (ajaxCartElement) {
          ajaxCartElement.classList.remove('is-empty');
        }
        if (cartProElement) {
          cartProElement.classList.remove('is-empty');
        }

        if (ajaxCartElement && typeof ajaxCartElement.renderContents === 'function') {
          try {
            ajaxCartElement.renderContents(data);
          } catch (err) {
            console.error('Error running renderContents, falling back to manual DOM updates:', err);
            this.fallbackRender(data);
          }
        } else {
          this.fallbackRender(data);
        }

        if (window.vela && typeof window.vela.updateCart === 'function') {
          window.vela.updateCart();
        }

        submitBtn.classList.remove('loading');
        submitBtn.classList.add('success');
        submitBtn.querySelector('.btn-text').textContent = 'Added!';
        
        setTimeout(() => {
          submitBtn.classList.remove('success');
          submitBtn.disabled = false;
          submitBtn.querySelector('.btn-text').textContent = 'Add to Cart';
        }, 2000);
      })
      .catch(error => {
        console.error(error);
        submitBtn.classList.remove('loading');
        submitBtn.querySelector('.btn-text').textContent = error.message || 'Error';
        
        setTimeout(() => {
          submitBtn.disabled = false;
          submitBtn.querySelector('.btn-text').textContent = 'Add to Cart';
        }, 3000);
      });
    }

    fallbackRender(data) {
      if (data.sections && data.sections['ajax-cart']) {
        const parsed = new DOMParser().parseFromString(data.sections['ajax-cart'], 'text/html');
        const result = parsed.querySelector('#ajaxcart');
        const target = document.querySelector('#ajaxcart');
        if (result && target) {
          target.innerHTML = result.innerHTML;
        }
      }
      if (data.sections && data.sections['ajax-cart-icon']) {
        const parsedCount = new DOMParser().parseFromString(data.sections['ajax-cart-icon'], 'text/html');
        const resultCount = parsedCount.querySelector('.bigcounter');
        const targetCount = document.querySelector('.bigcounter');
        if (resultCount && targetCount) {
          targetCount.innerHTML = resultCount.innerHTML;
        }
      }
      
      document.querySelectorAll('.is-empty').forEach(el => {
        el.classList.remove('is-empty');
      });

      const drawer = document.querySelector('ajax-cart');
      if (drawer) {
        drawer.classList.add('animate', 'active');
      }
    }
  }
  customElements.define('custom-product-card', CustomProductCard);
}
